import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
`

export const Box = styled.div<{ size?: number | string }>`
  flex-grow: ${(props) => props.size};
`
